const { getTranslationDictionary } = require('core');

module.exports = function extractEventText(type, isActual) {
	const translationDictionary = getTranslationDictionary();
	const propertyName = `${type}${isActual ? 'ed' : ''}Event`;
	return translationDictionary[propertyName];
};
